import React from 'react';
import PropTypes from 'prop-types';
import { BrandContext } from '../../../contexts/branding';

export const PureLDBreadcrumbs = ( { paths } ) => {
  const brandConfig = React.useContext(BrandContext);
  const { siteUrl } = brandConfig;
  const JsonLD = JSON.stringify({
    '@type': 'BreadcrumbList',
    '@id': `${siteUrl}/#breadcrumb`,
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'item': {
          '@type': 'WebPage',
          '@id': `${siteUrl}/`,
          'url': `${siteUrl}/`,
          'name': 'Home'
        }
      },
      ...paths.map(( { path, name }, index ) => {
        return {
          '@type': 'ListItem',
          'position': 2 + index,
          'item': {
            '@type': 'WebPage',
            '@id': `${siteUrl}${path}`,
            'url': `${siteUrl}${path}`,
            'name': name,
          }
        };
      }),
    ]
  });
  return (
    <React.Suspense fallback={null}>
      <script type="application/ld+json" >
        {JsonLD}
      </script>
    </React.Suspense>
  );
};

PureLDBreadcrumbs.propTypes = {
  paths: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }))
};

PureLDBreadcrumbs.defaultProps = {
  paths: [],
};

export default PureLDBreadcrumbs;
